import React, { useEffect, useMemo } from "react";
import { PeekSelect, PeekSelectOption } from "@piiqtechnologies/ui-components";
export const ALL_AI_MODELS_OPTION_VALUE = "all";
const GEMINI_AI_MODEL_VALUE = "gemini";
export const ALL_AI_MODELS_OPTION = {
    value: ALL_AI_MODELS_OPTION_VALUE,
    label: "All AI Models",
};
const DEFAULT_AI_MODEL_OPTIONS = [
    ALL_AI_MODELS_OPTION,
    { value: "chatgpt", label: "ChatGPT" },
    { value: "gemini", label: "Gemini" },
    { value: "perplexity", label: "Perplexity" },
    { value: "claude", label: "Claude" },
];
const buildSelectOptions = (options) => {
    if (!(options === null || options === void 0 ? void 0 : options.length)) {
        return DEFAULT_AI_MODEL_OPTIONS;
    }
    const seenValues = new Set();
    const uniqueOptions = options.reduce((acc, option) => {
        if (!option || seenValues.has(option.value) || option.value === ALL_AI_MODELS_OPTION_VALUE) {
            return acc;
        }
        seenValues.add(option.value);
        acc.push(option);
        return acc;
    }, []);
    return [ALL_AI_MODELS_OPTION, ...uniqueOptions];
};
export const AiModelSelector = ({ selectedModel, onModelChange, options, isFreeTrial = false, disabled = false, }) => {
    const selectOptions = useMemo(() => buildSelectOptions(options), [options]);
    const hasGeminiOption = useMemo(() => selectOptions.some((option) => option.value.toLowerCase() === GEMINI_AI_MODEL_VALUE || option.label.toLowerCase() === GEMINI_AI_MODEL_VALUE), [selectOptions]);
    const normalizedSelectedModel = selectedModel.toLowerCase();
    useEffect(() => {
        if (!isFreeTrial || !hasGeminiOption) {
            return;
        }
        if (normalizedSelectedModel === GEMINI_AI_MODEL_VALUE) {
            return;
        }
        onModelChange(GEMINI_AI_MODEL_VALUE);
    }, [hasGeminiOption, isFreeTrial, onModelChange, normalizedSelectedModel]);
    return (React.createElement(PeekSelect, { value: selectedModel, onChange: (event) => onModelChange(event.target.value), size: "small", disabled: disabled, inputProps: { disabled }, sx: Object.assign({ minWidth: 150, "& .MuiSelect-select": {
                py: 0.75,
                fontSize: "14px",
            } }, (disabled && {
            pointerEvents: "none",
            opacity: 0.6,
        })) }, selectOptions.map((option) => {
        const normalizedValue = option.value.toLowerCase();
        const normalizedLabel = option.label.toLowerCase();
        const isGemini = normalizedValue === GEMINI_AI_MODEL_VALUE || normalizedLabel === GEMINI_AI_MODEL_VALUE;
        const isDisabled = isFreeTrial && !isGemini;
        return (React.createElement(PeekSelectOption, { key: option.value, value: option.value, disabled: isDisabled }, option.label));
    })));
};
